module.exports = __webpack_public_path__ + "img/verify-id.568f14dd.jpg";